import script from "./OneService.vue?vue&type=script&setup=true&lang=js"
export * from "./OneService.vue?vue&type=script&setup=true&lang=js"

import "./OneService.vue?vue&type=style&index=0&id=232563aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-232563aa"]])

export default __exports__